import React from "react";
import { Navigate } from "react-router-dom";

function RequireAuth({ children }) {
  const authData = JSON.parse(localStorage.getItem("authData"));
  if (!authData || !authData?.token) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export default RequireAuth;
